import React from 'react';

const ProfileStats = ({ 
  animeCollection,
  mangaCollection,
  favoriteCharacters
}) => {
  // Calculate total anime stats
  const getTotalEpisodesWatched = () => {
    let total = 0;
    Object.values(animeCollection).forEach(statusList => {
      statusList.forEach(anime => {
        total += anime.currentEpisode || 0;
      });
    });
    return total;
  };

  const getTotalChaptersRead = () => {
    let total = 0;
    Object.values(mangaCollection).forEach(statusList => {
      statusList.forEach(manga => {
        total += manga.currentChapter || 0;
      });
    });
    return total;
  };

  const getTotalAnimeCount = () => {
    return Object.values(animeCollection).reduce((count, list) => count + list.length, 0);
  };

  const getTotalMangaCount = () => {
    return Object.values(mangaCollection).reduce((count, list) => count + list.length, 0);
  };

  return (
    <div className="info-card profile-card">
      <h2>Activity Stats</h2>
      <div className="stats-grid">
        <div className="stat-item">
          <span className="stat-number">
            {getTotalEpisodesWatched()}
          </span>
          <span className="stat-label">Episodes Watched</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">
            {getTotalChaptersRead()}
          </span>
          <span className="stat-label">Chapters Read</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">
            {getTotalAnimeCount()}
          </span>
          <span className="stat-label">Total Anime</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">
            {getTotalMangaCount()}
          </span>
          <span className="stat-label">Total Manga</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">
            {favoriteCharacters.length}
          </span>
          <span className="stat-label">Favorite Characters</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileStats;